import { combineReducers } from '@reduxjs/toolkit';
import { createHoaDetailsSlice, deleteHoaDetailsSlice, getHoaDetailsSlice, updateHoaDetailsSlice } from './slices';

export const orderHoaReducer = combineReducers({
  createHoaDetailsSlice: createHoaDetailsSlice.reducer,
  getHoaDetailsSlice: getHoaDetailsSlice.reducer,
  updateHoaDetailsSlice: updateHoaDetailsSlice.reducer,
  deleteHoaDetailsSlice: deleteHoaDetailsSlice.reducer,
});
